import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GridLegacy, List, ListItem, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import AsynchronousAutocomplete from "../../../../components/Autocomplete/AsynchronousAutocomplete";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../../components/CustomButtons/Button";
import { Link } from "react-router";
import { Visibility } from "@mui/icons-material";

export default function Products() {
  const { control } = useFormContext();
  const { fields, replace } = useFieldArray({
    control,
    name: "products",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <Typography variant={"h5"}>
              <TranslationWrapper
                tDefault={"Packaging applied to following products"}
                tKey={"packagings.products_title"}
              />
            </Typography>
          </GridLegacy>
          <GridLegacy item xs={12}>
            <AddChildProduct fields={fields} replace={replace} />
          </GridLegacy>
          <GridLegacy item xs={12}>
            <List>
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={6}>
                    <TranslationWrapper tKey={"Product name"} />
                  </GridLegacy>
                  <GridLegacy item xs={6} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem key={field.value}>
                    <GridLegacy container>
                      <GridLegacy item xs={6}>
                        <Typography style={{ margin: "0 16px" }}>
                          {field.naam} - {field.prijs}
                        </Typography>
                      </GridLegacy>

                      <GridLegacy item xs={6}>
                        <Link to={`/manager/producten/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Visibility />
                            </Button>
                          </Tooltip>
                        </Link>
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>
          </GridLegacy>
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

function AddChildProduct({ replace, fields }) {
  const { menukaartVestigingId } = useFormContext();

  return (
    <AsynchronousAutocomplete
      async={{
        url: `core/producten/search?fields=id as value,id,naam as label,prijs,vestiging_id,naam,sortkey&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
        searchField: "naam",
        perPage: 20,
      }}
      key={menukaartVestigingId}
      multiple={true}
      onChange={(e, option) => {
        replace(option);
      }}
      placeholder={getTranslation("Find product")}
      value={(fields ?? []).map((field) => {
        field.value = field.id = field.id ?? field.value;
        field.label = field.naam = field.naam ?? field.label;

        return field;
      })}
    />
  );
}
